import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Home from "./components/Home";
import MyNavbar from "./components/navbar";
import AboutMe from "./pages/about";
import Projects from "./pages/projects";
import TabComponent from "./pages/skills";
import Footer from "./components/footer";
import WorkExperience from "./pages/work";
import Education from "./pages/education";
import CertificationSection from "./pages/certificate";
//import BlogSection from "./pages/blog";
import TermsAndConditions from "./pages/terms";
import CopyrightPage from "./pages/copy";
import PrivacyPolicy from "./pages/policy";
import ResumeSection from "./resume/resume_page";

function App() {
  return (

 <Router>
<MyNavbar/>

<Routes>

  <Route path= "/" element={<Home/>} ></Route>
  <Route path= "/about" element={<AboutMe/>} ></Route>
  <Route path= "/skills" element={<TabComponent/>} ></Route>
  <Route path= "/projects" element={<Projects/>} ></Route>
  <Route path= "/experience" element={<WorkExperience/>} ></Route>
  <Route path= "/certificates" element={<CertificationSection/>} ></Route>
  <Route path= "/education" element={<Education/>} ></Route>
  {/* <Route path= "/blog" element={<BlogSection/>} ></Route> */}
  <Route path= "/terms" element={<TermsAndConditions/>} ></Route>
  <Route path= "/copy" element={<CopyrightPage/>} ></Route>
  <Route path= "/policy" element={<PrivacyPolicy/>} ></Route>
  <Route path= "/resume" element={<ResumeSection/>} ></Route>



</Routes>
<Footer/>

 </Router>
 
  );
}

export default App;


